import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { NavLink } from 'react-router-dom';
import { ListItemText, Avatar } from '@material-ui/core';
import { RssFeed } from '@material-ui/icons';
import { Announcement } from '@material-ui/icons';
import { Link } from '@material-ui/icons';
import { Explore } from '@material-ui/icons';
import { Event } from '@material-ui/icons';
import { Description } from '@material-ui/icons';
import { People } from '@material-ui/icons';
import { Subject } from '@material-ui/icons';
import { List as ListIcon } from '@material-ui/icons';
import { Home } from '@material-ui/icons';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    // height: '100vh',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'absolute',
    backgroundColor: theme.palette.appTopBar.backgroundColor,
    marginLeft: drawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
  appBarTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  navIconClose: {
    color: theme.palette.sideDraw.secondary,
  },
  navList: {
    padding: 0,
  },
  navLink: {
    textDecoration: 'none',
    color: theme.palette.grey[400],
    borderBottom: '1px solid #454545',
    width: '100%',
    '&:hover': {
      color: '#fff',
    }
  },
  active: {
    color: '#fff',
    backgroundColor: '#545454'
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: '0 4px',
    backgroundColor: '#262626',
    ...theme.mixins.toolbar,
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.sideDraw.main,
    [theme.breakpoints.up('md')]: {
      position: 'relative',
      height: '100vh',
    },
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflowY: 'auto',
  },
});

class SideDraw extends React.Component {
  state = {
    mobileOpen: false,
  };

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  };

  handleDrawerClose = () => {
    this.setState({ mobileOpen: false });
  };

  render() {
    const { settings, translations, appLanguage, routes, classes, children, isActiveModule, icon } = this.props;

    const drawer = (
      <Fragment>
        <div className={classes.drawerHeader} >
          <NavLink to={routes.dashboard}>
            <img src={require('./admin_logo.png')} style={{display: 'block', width: 'auto', maxHeight: 25}} alt='logo' />
          </NavLink>
          <IconButton className={`${classes.navIconHide} ${classes.navIconClose}`} onClick={this.handleDrawerToggle}>
            <ChevronLeftIcon  />
          </IconButton>
        </div>
          <List className={classes.navList}>  
            <ListItem
              component={NavLink}
              to={routes.dashboard}
              exact
              className={classes.navLink}
              activeClassName={classes.active}
              button
              onClick={this.handleDrawerClose}
            >
              <ListItemIcon><Home /></ListItemIcon>
              <ListItemText>
                <Typography color='inherit' variant={"subtitle1"}>
                  Portal Dashboard
                </Typography>
              </ListItemText>
            </ListItem>
            { isActiveModule('Alerts') ? 
              <ListItem
                component={NavLink}
                to={routes.alerts}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><Announcement /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {`General ${translations.t_TITLE_ALERTS[appLanguage]}`}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('Events') ?
              <ListItem
                component={NavLink}
                to={routes.events}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><Event /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_TITLE_EVENTS[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('Notices') ?
              <ListItem
                component={NavLink}
                to={routes.notices}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><Description /></ListItemIcon>
                <ListItemText>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_TITLE_NOTICES[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('rssReader') ?
              <ListItem
                component={NavLink}
                to={routes.rssReader}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><RssFeed /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_MODULE_RSSREADER_TITLE[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('Links') ?
              <ListItem
                component={NavLink}
                to={routes.links}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><Link /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_TITLE_LINKS[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('linksList') ?
              <ListItem
                component={NavLink}
                to={routes.linksList}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><Subject /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_MODULE_LINKLIST_TITLE[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('Maps') ?
              <ListItem
                component={NavLink}
                to={routes.maps}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><Explore /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_TITLE_MAPS[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null 
            }
            { isActiveModule('Contacts') ?
              <ListItem
                component={NavLink}
                to={routes.contacts}
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              > 
                <ListItemIcon><People /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_TITLE_CONTACTS[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
            { isActiveModule('termDates') ?
              <ListItem
                component={NavLink}
                to={routes.termDates} 
                className={classes.navLink}
                activeClassName={classes.active}
                button
                onClick={this.handleDrawerClose}
              >
                <ListItemIcon><ListIcon /></ListItemIcon>
                <ListItemText inset>
                  <Typography color='inherit' variant={"subtitle1"}>
                    {translations.t_MODULE_TERMDATES_TITLE[appLanguage]}
                  </Typography>
                </ListItemText>
              </ListItem>
              : null
            }
          </List>
      </Fragment>
    );

    return (
      <div className={classes.root}>
        <AppBar color='secondary' className={classes.appBar} >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={this.handleDrawerToggle}
              className={classes.navIconHide}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.appBarTitle}>
              <Avatar src={icon} alt={settings.SCHOOL_NAME} style={{marginRight: 10}}/>
              <Typography variant="h6" color="inherit" noWrap style={{paddingTop: 5}}>
                {settings.SCHOOL_NAME}
              </Typography>
            </div>
          </Toolbar>
        </AppBar>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <Drawer
            variant="permanent"
            open
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          {children}
        </main>
      </div>
    );
  }
}

SideDraw.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(SideDraw);


// WEBPACK FOOTER //
// ./src/components/containers/Layout.js